// Form validation utilities for price parts
// Extracted from apps/web/src/components/common/antd-form-utils.ts

/**
 * Check if form errors object is empty (Ant Design Form equivalent of formikErrorEmpty)
 */
const antdFormErrorEmpty = (errors: any[]): boolean => {
  if (!errors || errors.length === 0) {
    return true;
  }

  for (const error of errors) {
    if (error && error.errors && error.errors.length > 0) {
      return false;
    }
  }

  return true;
};

/**
 * Validate if a number value is valid (not null, undefined, empty string, or NaN)
 */
const isValidNumber = (value: any): boolean => {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  const num = Number(value);
  return !isNaN(num);
};

/**
 * Opposite of isValidNumber for backward compatibility
 */
const isNotValidNumber = (value: any): boolean => {
  return !isValidNumber(value);
};

export { antdFormErrorEmpty, isValidNumber, isNotValidNumber };
